import { Maybe } from "@/domains/common/types";
import { AppStore } from "@/store/AppStore";
import { SessionEventModelData, SessionEventKind } from "@/store/sessions/types";
import { OptimisticSyncUpdate, SyncUpdateValue } from "@/store/sync/types";

export type SessionEventIndexData = {
  kind: SessionEventKind;
  locally_created_at: string;
  session_id: string;
};

export class SessionEventIndexes {
  private store: AppStore;
  private data: SyncUpdateValue<SessionEventModelData>;

  constructor({
    store,
    remoteData,
    optimisticUpdates,
  }: {
    store: AppStore;
    remoteData: Maybe<SyncUpdateValue<SessionEventModelData>>;
    optimisticUpdates: OptimisticSyncUpdate<SessionEventModelData>[];
  }) {
    this.store = store;
    this.data =
      (optimisticUpdates.at(-1)?.value as SyncUpdateValue<SessionEventModelData>) || remoteData;
  }

  get kind(): SessionEventKind {
    return this.data.model_data.kind as SessionEventKind;
  }

  get locally_created_at(): string {
    return this.data.model_data.locally_created_at;
  }

  get session_id(): string {
    return this.data.model_data.session_id;
  }

  get indexes(): SessionEventIndexData {
    return {
      kind: this.kind,
      locally_created_at: this.locally_created_at,
      session_id: this.session_id,
    };
  }
}
